export type ID = number;

export const Currency = {
  UYU: 'UYU',
  USD: 'USD',
} as const;
export type Currency = typeof Currency[keyof typeof Currency];

